import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, TimeoutError } from 'rxjs';
import { UiService } from '@state/ui/ui.service';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { ToastService } from '@core/services/toast/toast.service';
import { LibraryService } from '@core/services/library/library.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    private requestCount = 0;

    constructor(
        private libraryService: LibraryService,
        private toastService: ToastService,
        private uiService: UiService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timeoutValue = req.headers.get('timeout') || 30000;
        const timeoutValueNumeric = Number(timeoutValue);

        if (this.requestCount === 0) {
            this.uiService.setLoading(true);
        }

        this.requestCount++;

        return next.handle(req).pipe(
            finalize(() => {
                this.requestCount--;

                if (this.requestCount === 0) {
                    this.uiService.setLoading(false);
                }
            }),
            timeout(timeoutValueNumeric),
            catchError(err => {
                if (err instanceof TimeoutError) {
                    this.toastService.presentErrorToast(this.libraryService.getLabel('lbl_timeout'));
                }

                throw err;
            }));
    }
}
